import { memo } from 'react';
import type { NavItem } from './types';
import { ColumnLabel } from './ColumnLabel';
import { FeaturedContentCard } from './FeaturedContentCard';

interface FeaturedContentColumnProps {
  column: NavItem;
}

export const FeaturedContentColumn = memo(function FeaturedContentColumn({
  column,
}: FeaturedContentColumnProps) {
  const contentItems = (column.children ?? []).filter(
    (item) => item.type === 'featured',
  );

  return (
    <div className='relative mt-lg flex w-full flex-col border-t border-neutral-200 pt-lg lg:mt-0 lg:w-1/2 xl:w-1/3 lg:border-t-0 lg:pl-lg lg:pt-0 lg:before:absolute lg:before:left-0 lg:before:top-0 lg:before:h-full lg:before:w-px lg:before:bg-neutral-200 gap-md'>
      <ColumnLabel item={column} variant='prominent' />
      {contentItems.length > 0 && (
        <div className='flex flex-row gap-lg pt-xl lg:gap-sm lg:pt-sm xl:flex-col xl:gap-md xl:pt-lg'>
          {contentItems.map((item) => (
            <FeaturedContentCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
});
